import { Modal, Button } from 'react-bootstrap';
import { Locale } from '../../libraries';
const DeleteConfirmationModal = ({ showModal, handleClose, deleteOperation, message }) => {
    const { t } = Locale();
    return <>

        <Modal
            show={showModal}
            onHide={handleClose}
            dialogClassName="custom-modal customModal"
        >
            <Modal.Header
                closeButton
                className="headerLine"
                onClick={handleClose}
            />
            <Modal.Body>
                <div className="text-center">
                    <p className="delete-pop-up-message">
                       
                        {message}
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center footerLine">
                <Button
                    className="btn btn-light cancelbutton"
                    onClick={handleClose}
                >
                    {t('button.cancelButton')}
                </Button>
                <Button
                    className="btn btn-light deletebutton"
                    onClick={deleteOperation}
                >
                    {t('button.yes')}
                </Button>
            </Modal.Footer>
        </Modal>
    </>
}

export default DeleteConfirmationModal;